import { logger } from '../../../utils/logger'
import { getJsonSessionItem, SessionStorage } from '../../../utils/session-storage'
import type { ServiceHandler } from './service-registry'
import { getSessionStorageMetadataKey } from './setMetadata'
import type {
  GetMetadataRequest,
  GetMetadataResponse,
} from '@custom-embedded-code-sdk/methods/metadata'

/**
 * GET_METADATA service handler
 *
 * Handles requests to retrieve all metadata for the current campaign from session storage.
 * The session storage key is `metadata_{campaignId}`
 *
 * If no metadata is found, simply return an empty object.
 */
export const getMetadata: ServiceHandler<GetMetadataRequest, GetMetadataResponse> = async ({
  iframeId,
  messageId,
  sendSuccessResponse,
  sendErrorResponse,
  pageConfig,
}) => {
  const campaignId = pageConfig.campaignId

  try {
    if (!campaignId) {
      throw new Error('CustomEmbeddedCode:getMetadata: Campaign ID not available')
    }

    const storageKey = getSessionStorageMetadataKey(campaignId)
    const metadata = (getJsonSessionItem<SessionStorage>(storageKey) || {}) as GetMetadataResponse

    logger('info', 'CustomEmbeddedCode:getMetadata: Successfully retrieved metadata', {
      context: { iframeId, messageId, campaignId, storageKey },
    })

    sendSuccessResponse(iframeId, messageId, metadata)
  } catch (error) {
    logger(
      'error',
      new Error('CustomEmbeddedCode:getMetadata: Failed to get metadata', { cause: error }),
      {
        context: { iframeId, messageId, campaignId },
      },
    )
    sendErrorResponse(iframeId, messageId, 'Unable to get metadata')
  }
}
